'use strict';

const queue = [];
let queueTimeout;
let queueProgress = false;

/**
 * Adds a callback together with a duration to the list. Once the duration is
 * expired the callback is removed from the list. Currently this only supports
 * 2 callbacks at once. If more are added they will overwrite the last
 * callback. The reason for this is that you do not want to wait for 10 toaster
 * messages to show and hide.
 *
 * @param {function} callback - The callback to run
 * @param {number} duration - The duration of the callback in milliseconds
 */
function addToQueue(callback, duration) {
    if (typeof callback === 'function') {
        const idx = getNextIndex();

        queue[idx] = {
            callback: callback,
            duration: duration || 0
        };

        runQueue();
    }
}

/**
 * Runs the first callback from the queue and sets a timout for the next one.
 */
function runQueue() {
    if (!queueProgress) {
        const item = queue[0];
        item.callback();

        queueProgress = true;
        queueTimeout = setTimeout(processNextItem, item.duration);
    }
}

/**
 * Prepares the queue for the next callback if present.
 */
function processNextItem() {
    queue.shift();
    queueProgress = false;
    window.clearTimeout(queueTimeout);

    if (queue.length) {
        runQueue();
    }
}

/**
 * Gets the next possible index of the queue to add a callback to. This can be
 * extended later to handle more then 2 callbacks (see comment addToQueueu
 * method).
 *
 * @returns {number} The next index
 */
function getNextIndex() {
    return queue.length > 0 ? 1 : 0;
}

const actionQueue = {
    addToQueue: addToQueue
};

module.exports = actionQueue;
